import { Box } from "@mui/material";
import { motion } from "framer-motion";
import { useMotionConfig } from "./useMotionConfig";

const MotionBox = motion(Box);

const containerVariants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.12, delayChildren: 0.05 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 40, scale: 0.98 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.6, ease: [0.21, 0.6, 0.27, 0.97] },
  },
};

/** Container that staggers the appearance of its <StaggerItem> children. */
export function Stagger({ children, amount = 0.2, sx, ...rest }) {
  const { disabled } = useMotionConfig();

  if (disabled) {
    return (
      <Box sx={sx} {...rest}>
        {children}
      </Box>
    );
  }

  return (
    <MotionBox
      sx={sx}
      variants={containerVariants}
      initial="hidden"
      animate="show"
      {...rest}
    >
      {children}
    </MotionBox>
  );
}

export function StaggerItem({ children, sx, ...rest }) {
  const { disabled } = useMotionConfig();

  if (disabled) {
    return (
      <Box sx={sx} {...rest}>
        {children}
      </Box>
    );
  }

  return (
    <MotionBox sx={sx} variants={itemVariants} {...rest}>
      {children}
    </MotionBox>
  );
}
